import { ErrorDetail } from '../../types';

export type LoginRecordColumn =
    | 'loggedin_at'
    | 'node_name'
    | 'node_host'
    | 'node_type_name'
    | 'node_account_name'
    | 'status_alias'
    | 'application_form_numbers'
    | 'node_group_name';

export interface LoginRecordSearchInfo {
    id: number;
    node_id: number;
    loggedin_at: string;
    node_name: string;
    node_host: string;
    node_type_name: string;
    node_account_name: string;
    status_alias: string;
    application_form_numbers: string;
    node_group_name: string;
    rec_file_exist: boolean;
}

export const LoginRecordStatuses = [
    'unmatched',
    'normal',
    'illegal',
    'warning',
    'management_login',
    'unmanaged_account',
] as const;
export type LoginRecordStatus = (typeof LoginRecordStatuses)[number];
export function isLoginRecordStatus(p: unknown): p is LoginRecordStatus {
    return LoginRecordStatuses.some(s => s === p);
}

export interface LoginRecordState {
    loginRecords?: Array<LoginRecordSearchInfo>;
    loginRecordCount: number;
    recFilePath?: Array<string>;
    search: {
        isProcessing: boolean;
        isFetchSuccess: boolean;
        error: boolean;
        errorCode?: string;
        errorMsg?: string;
    };
    csv: {
        isProcessing: boolean;
        error: boolean;
        errorTitle?: string;
        errorDetails?: Array<ErrorDetail>;
    };
    recFile: {
        isProcessing: boolean;
        isFetchSuccess: boolean;
        error: boolean;
        errorTitle?: string;
        errorDetails?: Array<ErrorDetail>;
    };
}
